var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { Button, Grid, Pill } from '../../shared';
import { services } from '../../../shared/api/services';
import { Tabs } from '../../sections/tabs/tabs';
import { Tab } from '../../sections/tabs/tab/tab';
import { saveAs } from 'file-saver';
import './case-tracking.scss';
import { ApplicationFormStatus, FormType } from '../../../shared/types/enums';
export var CaseTracking = function (_a) {
    var _b;
    var workflowSteps = _a.workflowSteps, caseStages = _a.caseStages, caseId = _a.caseId, showUploadModal = _a.showUploadModal;
    var rowData = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.filter(function (step) { return step.id > 1; });
    var _c = useState(false), isDownloading = _c[0], setIsDownloading = _c[1];
    var downloadStageDoc = function (docId, stage, mimeType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsDownloading(true);
            services.getDownloadDocument(docId).then(function (blob) {
                saveAs(blob, "".concat(stage, "-").concat(caseId, ".").concat(mimeType === null || mimeType === void 0 ? void 0 : mimeType.split('/')[1]));
                setIsDownloading(false);
            });
            return [2 /*return*/];
        });
    }); };
    var downloadApplicationFormDoc = function (formId, formType) { return __awaiter(void 0, void 0, void 0, function () {
        var documentName, result, _a, esisDocumentId;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsDownloading(true);
                    documentName = "".concat(formType, "-").concat(caseId, ".pdf");
                    result = null;
                    _a = formType === FormType[FormType.DIP];
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.isDipCertificateAvailable(caseId, formId)];
                case 1:
                    _a = (_c.sent());
                    _c.label = 2;
                case 2:
                    if (!_a) return [3 /*break*/, 4];
                    return [4 /*yield*/, services.getDownloadCertificate(caseId, formId)];
                case 3:
                    result = _c.sent();
                    return [3 /*break*/, 10];
                case 4:
                    if (!(formType === FormType[FormType.Illustration])) return [3 /*break*/, 8];
                    return [4 /*yield*/, services.getEsisDocumentId(caseId, formId)];
                case 5:
                    esisDocumentId = (_b = (_c.sent()).data) !== null && _b !== void 0 ? _b : 0;
                    if (!(esisDocumentId > 0)) return [3 /*break*/, 7];
                    return [4 /*yield*/, services.getDownloadIllustration(esisDocumentId)];
                case 6:
                    result = _c.sent();
                    _c.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, services.getDownloadForm(caseId, formId)];
                case 9:
                    result = _c.sent();
                    _c.label = 10;
                case 10:
                    saveAs(result, documentName);
                    setIsDownloading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var buildDownloadLink = function (url, filename) {
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
    };
    var columns = [
        {
            id: 'formType',
            description: 'Form',
            sort: false,
        },
        {
            id: 'applicationFormStatus',
            description: 'Status',
            render: function (column, row) {
                var _a, _b;
                return (React.createElement(Pill, { formStatus: row[column.id] == 0 ? ApplicationFormStatus.NoStatus : (_a = row[column.id]) !== null && _a !== void 0 ? _a : ApplicationFormStatus.NoStatus }, row[column.id] == 0 ? ApplicationFormStatus.Active : (_b = row[column.id]) !== null && _b !== void 0 ? _b : ApplicationFormStatus.Active));
            },
            sort: false,
        },
        {
            id: 'dateUpdated',
            description: 'Submission Date',
            sort: false,
            render: function (column, row) {
                var _a;
                if (!row[column.id])
                    return React.createElement(React.Fragment, null);
                var date = new Date(Date.parse((_a = row[column.id]) !== null && _a !== void 0 ? _a : Date.now));
                return React.createElement(React.Fragment, null, date.toLocaleDateString('en-GB'));
            },
        },
        {
            id: 'download',
            description: 'Download',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Button, { variant: "secondary", type: "button", icon: "download", iconPosition: "left", onClick: function () { return downloadApplicationFormDoc(row.formId, row.formType); }, disabled: row.formType === FormType[FormType.Illustration] && !row.hasDocument }, "Download"));
            },
        },
    ];
    var stageColumns = [
        {
            id: 'name',
            description: 'Form',
            sort: false,
        },
        {
            id: 'statusId',
            description: 'Status',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Pill, { stageStatus: row.isComplete ? ApplicationFormStatus.Completed : ApplicationFormStatus.Active }, row[column.id]));
            },
        },
        {
            id: 'modifiedOn',
            description: 'Submission Date',
            sort: false,
            render: function (column, row) {
                var date = row[column.id] == null ? '' : new Date(Date.parse(row[column.id])).toLocaleDateString('en-GB');
                return React.createElement(React.Fragment, null, row[column.id] && date);
            },
        },
        {
            id: 'upload',
            description: 'Upload',
            sort: false,
            render: function (column, row) {
                if (row === null || row === void 0 ? void 0 : row.isAllowUploadDocumentBroker)
                    return (React.createElement(Button, { variant: "secondary", type: "button", icon: "upload", iconPosition: "left", disabled: row.isComplete || row.applicationFormStatus == ApplicationFormStatus.Completed, onClick: showUploadModal, dataValue: row.applicationStageComponentId }, "Upload"));
            },
        },
        {
            id: 'download',
            description: 'Download',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Button, { variant: "secondary", type: "button", icon: "download", iconPosition: "left", disabled: isDownloading || row.documentId == 0, onClick: function () { return downloadStageDoc(row.documentId, row.name, row.documentMimeType); } }, "Download"));
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { id: "case-tracking" },
            React.createElement(Tab, { title: "Application", icon: "application", showNotification: true, extendNotificationClass: !((_b = workflowSteps === null || workflowSteps === void 0 ? void 0 : workflowSteps.some(function (step) { return !step.isComplete; })) !== null && _b !== void 0 ? _b : true) ? 'complete' : 'active' },
                React.createElement(Grid, { columns: columns, rowData: rowData !== null && rowData !== void 0 ? rowData : [], noRowsMessage: "No case tracking details are currently available." })), caseStages === null || caseStages === void 0 ? void 0 :
            caseStages.map(function (stage) {
                var _a, _b, _c, _d;
                return (React.createElement(Tab, { key: "tab-".concat(stage.name), title: stage.name, icon: stage.icon, showNotification: (_a = stage.components) === null || _a === void 0 ? void 0 : _a.some(function (step) { return step.modifiedOn != null; }), extendNotificationClass: !((_c = (_b = stage.components) === null || _b === void 0 ? void 0 : _b.some(function (step) { return !step.isComplete; })) !== null && _c !== void 0 ? _c : true) ? 'complete' : 'active' },
                    React.createElement(Grid, { columns: stageColumns, rowData: (_d = stage.components) !== null && _d !== void 0 ? _d : [], noRowsMessage: "No case tracking details are currently available." })));
            }))));
};
